import React, { useEffect } from "react";

import { getApp } from "../../ts/index.js";

import registerCustomElement from "./registerCustomElement.jsx";

if (import.meta.env.VITE_CAPTCHA_API_KEY) {
  window.awsWafCookieDomainList = [import.meta.env.VITE_CAPTCHA_API_KEY];
}

function WafCaptcha() {
  useEffect(() => {
    void (async () => {
      const app = await getApp();

      const container = document.querySelector("#waf-captcha");
      if (!container) {
        console.error("Unable to find the WAF captcha wrapper");
        return;
      }

      if (!window.AwsWafCaptcha) {
        console.error("AwsWafCaptcha is not loaded");
        return;
      }

      if (!import.meta.env.VITE_CAPTCHA_API_KEY) {
        console.error("Missing VITE_CAPTCHA_API_KEY");
        return;
      }

      window.AwsWafCaptcha.renderCaptcha(container, {
        apiKey: import.meta.env.VITE_CAPTCHA_API_KEY,
        onSuccess: (wafCaptchaToken: string) => {
          localStorage.setItem("wafCaptchaToken", wafCaptchaToken);
          app.ports.interopToElm.send({
            name: "setWafCaptchaToken",
            value: { wafCaptchaToken },
          });
        },
        onError: (error: any) => {
          console.error("Waf captcha error:", error);
          // app.ports.interopToElm.send({
          //   name: "setWafCaptchaToken",
          //   value: { wafCaptchaToken: "fake" },
          // });
        },
      });
    })();
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div id="waf-captcha" />
    </div>
  );
}

registerCustomElement(WafCaptcha, "waf-captcha-element");
